function sanitizeFileNamePart(value: string): string {
  return value
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/\s+/g, " ")
    .trim();
}

function formatAsOfDate(date: Date): string {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function getChemicalInventoryExportFileName({
  tenantName,
  facilityName,
  reportingYear,
  asOf = new Date(),
}: {
  tenantName?: string;
  facilityName?: string;
  reportingYear?: number;
  asOf?: Date;
}): string {
  const tenant = sanitizeFileNamePart(tenantName ?? "");
  const prefix = tenant ? `${tenant} Chemical Inventory` : "Chemical Inventory";
  const yearLabel = reportingYear === undefined ? "all years" : String(reportingYear);
  const asOfLabel = formatAsOfDate(asOf);
  const site = facilityName ? sanitizeFileNamePart(facilityName) : "";
  if (site) {
    return `${prefix} at ${site} ${yearLabel} as of ${asOfLabel}.xlsx`;
  }
  return `${prefix} ${yearLabel} as of ${asOfLabel}.xlsx`;
}
